import { init as initProductCard } from "../snippets/product-card";

export function init() {
    const productsCarousel = document.querySelector(".products-carousel__wrapper");
    if (productsCarousel) {
        const cards = productsCarousel.querySelectorAll(".product-card");
        if (cards) {
            cards.forEach(initProductCard);
        }
    }
}